import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { client } from '@authy/lib-client/trpc'

import { rootRoute } from '@/tenant/settings/root'
import { appState } from '@/appState'

export const scopesRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/scopes',
    component: lazyRouteComponent(() => import('./Scopes'), 'Scopes'),
    loader: async ({ abortController, parentMatchPromise }) => {
        await parentMatchPromise

        const scopesSettings = await client.tenants.getTenantScopesSettings.query(
            {
                tenantId: appState.tenant!._id.toString(),
            },
            { signal: abortController.signal }
        )

        return { scopesSettings }
    },
})
